<template>
  <div>
    <v-toolbar color="pink" dark>
      <v-btn icon small flat :to="{name:'championship-list'}" v-if="!!champId">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-icon>list</v-icon>
      <v-toolbar-title>Team List {{championship && championship.name? " - "+championship.name: " - "+identity.displayName}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="isClub && championship.isRegistrationsOpen">
        <template slot="activator">
          <v-btn @click="registerTeam">
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Register new team</span>
      </v-tooltip>
            <v-tooltip bottom v-if="isAdmin">
        <template slot="activator">
          <v-btn @click="generateMatchReport" v-if="selectedTeams.length==2">
            <v-icon>list_alt</v-icon>
          </v-btn>
          <v-chip v-if="selectedTeams.length!==2">Select two teams</v-chip>
        </template>
        <span>{{selectedTeams.length==2?"Generate match report for selected teams":"Select exactly two teams to generate match report"}}</span>
      </v-tooltip>

    </v-toolbar>
    <v-card>
      <v-data-table
        v-model="selectedTeams"
        :loading="ui.loading"
        :headers="ui.headers"
        :items="teams"
        class="elevation-1"
        :pagination.sync="page"
        :total-items="page.totalItems"
        :no-data-text="emptyListText"
        :no-results-text="emptyListText"
      >
        <template v-slot:top></template>
        <template v-slot:items="props">
          <td>
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td>{{ props.item.championship.name }}</td>
          <td>{{ props.item.coach }}</td>
          <td>{{props.item.manager }}</td>
          <td>{{props.item.club.name }}</td>
          <td>
            <!-- <v-btn icon :to="{name:'team-editor',params:{id:props.item.id}}"><v-icon>edit</v-icon></v-btn> -->
            <v-btn
              color="primary"
              v-if="isClub"
              @click.prevent="openRoaster(props.item.id)"
            >Print Roster</v-btn>
            <v-btn v-if="isEditable(props.item)" :title="!championship.isRegistrationsOpen && !isAdmin?'Team registrations closed for this championship':'Modify team details'" :disabled="!championship.isRegistrationsOpen && !isAdmin" @click.prevent="editClub(props.item.id)">Edit Team</v-btn>
            <v-btn
              v-if="isAdmin"
              color="primary"
              @click.prevent="showCertificateOptions(props.item.id)"
            >Print Certificates</v-btn>
            <v-btn
              v-if="isAdmin"
              color="primary"
              @click.prevent="printBio(props.item.id)"
            >Print Player Details</v-btn>
            <v-btn
              color="primary"
              @click.prevent="printJersey(props.item.id)"
            >Print Jersey Form</v-btn>
            <v-menu offset-x v-if="options.showDeleteOption">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <v-toolbar color="pink" dark>
                <v-icon>delete</v-icon>
                <v-toolbar-title>Confirm deletion</v-toolbar-title>
              </v-toolbar>
              <v-card>
                <v-card-title>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div text-center>Are you sure you want to delete this record? This cannot be undone!</div>
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-card-actions>
                  <v-btn block>No</v-btn>
                  <v-btn block @click="deleteTeam(props.item.id)">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="certificates.show" max-width="700">
      <v-toolbar color="pink" dark>
        <v-toolbar-title>Provide Certificate Details</v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container grid-list-lg>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field v-model="certificates.place" placeholder="Place" />
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="certificates.date" placeholder="Date" />
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="certificates.secretary" placeholder="Name of Secretary" />
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="certificates.president" placeholder="Name of President" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="certificates.show=false">Cancel</v-btn>
          <v-btn @click="openCertificates" flat>Print Certificates</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-snackbar auto-height v-model="ui.showAlert" color="error" :timeout="600000">
      <span>{{ui.feedback}}</span>
      <v-btn dark flat @click="ui.showAlert = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      selectedTeams: [],
      championship: {},
      champId: "",
      teams: [],
      page: {
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        hasNextPage: false,
        hasPreviousPage: false
      },
      certificates: {
        teamId: "",
        place: "",
        date: "",
        president: "",
        secretary: "",
        show: false
      },
      ui: {
        loading: false,
        showAlert: false,
        feedback: "",
        headers: [
          {
            text: "Select",
            sortable: false,
            align: "left"
          },
          {
            text: "Championship",
            value: "name",
            sortable: false,
            align: "left"
          },
          {
            text: "Coach",
            value: "coach",
            sortable: false,
            align: "left"
          },
          {
            text: "Manager",
            value: "manager",
            sortable: false,
            align: "left"
          },
          {
            text: "Team",
            value: "club.name",
            sortable: false,
            align: "left"
          },
          {
            text: "Options",
            sortable: false,
            align: "left"
          }
        ]
      }
    };
  },
  computed: {
    ...mapState("config", ["identity", "meta","options"]),
    role: function() {
      return this.identity.type;
    },
    isAdmin: function() {
      return this.role == "Administrator";
    },
    isClub: function() {
      return this.role == "Club";
    },
    emptyListText: function() {
      return this.isAdmin
        ? "No teams registered under this championship"
        : this.champId
        ? "You have no teams registered under this championships"
        : "You have no registered teams";
    }
  },
  watch: {
    "page.page": function(n, o) {
      if (n !== o) this.reload();
    },
    "page.rowsPerPage": function(n, o) {
      if (n !== o) this.reload();
    },
    champId: function(nv) {
      this.loadChamp(nv);
    }
  },
  mounted: function() {
    this.reload();
  },
  methods: {
    reload: function() {
      this.champId = this.$route.params.id;

      var me = this;
      me.ui.loading = true;
      this.$api("teams")
        .get({
          championshipId: me.champId,
          page: this.page.page,
          pageSize: this.page.rowsPerPage
        })
        .then(function(resp) {
          me.teams = resp.items;
          me.page = _.omit(resp, "items");
        })
        .catch(function() {})
        .finally(function() {
          me.ui.loading = false;
        });
    },
    openRoaster: function(id) {
      var url =
        this.meta.apiUrl +
        "/reports/roster/" +
        id +
        "?key=" +
        this.identity.token;
      window.open(url);
    },
    showCertificateOptions: function(id) {
      this.certificates.teamId = id;
      this.certificates.show = true;
    },
    openCertificates: function() {
      var url =
        this.meta.apiUrl +
        "/reports/certificates/" +
        this.certificates.teamId +
        "?key=" +
        this.identity.token +
        "&secretary=" +
        this.certificates.secretary +
        "&president=" +
        this.certificates.president +
        "&place=" +
        this.certificates.place +
        "&date=" +
        this.certificates.date;
      window.open(url);
      this.certificates.show = false;
    },
    printBio: function(id) {
      var url =
        this.meta.apiUrl +
        "/reports/playerbio/team/" +
        id +
        "?key=" +
        this.identity.token;
      window.open(url);
    },
    generateMatchReport:function(){
      if(this.selectedTeams.length==2){
        var url=this.meta.apiUrl +"/reports/matchreport?key="+this.identity.token+"&team1="+this.selectedTeams[0].id+"&team2="+this.selectedTeams[1].id;
        window.open(url);
      }
    },
    isEditable(team) {
      return team.club.id == this.identity.id;
    },
    editClub: function(id) {
      this.$router.push({ name: "team-editor", params: { id: id } });
    },
    loadChamp: function(id) {
      var me = this;
      this.$api("championships")
        .get({ id: id })
        .then(function(resp) {
          me.championship = resp;
        })
        .catch(function() {});
    },
    registerTeam: function() {
      if (this.champId) {
        this.$router.push({
          name: "register-team",
          params: { champ: this.champId }
        });
      } else {
        this.$router.push({ name: "championship-list" });
      }
    },
    printJersey:function(id){
      var url=this.meta.apiUrl +"/reports/JerseyList?key="+this.identity.token+"&team1="+id;
       window.open(url);
    },
    deleteTeam: function(id) {
      var me = this;
      me.ui.feedback = "";
      me.ui.showAlert = false;
      this.$api("teams/" + id)
        .delete()
        .then(function() {
          var index = _.findIndex(me.teams, function(x) {
            return x.id == id;
          });
          if (index >= 0) {
            me.teams.splice(index, 1);
          }
        })
        .catch(function(xhr) {
          if (xhr && xhr.responseJSON && xhr.responseJSON.feedback) {
            me.ui.feedback = xhr.responseJSON.feedback;
          } else {
            me.ui.feedback = "An error occured";
          }
          me.ui.showAlert = true;
        });
    }
  }
};
</script>
